import { render, staticRenderFns } from "./ExaminationDetail.vue?vue&type=template&id=b21e2b22&"
import script from "./ExaminationDetail.vue?vue&type=script&lang=js&"
export * from "./ExaminationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports